/* DD cart-drawer cross-sell. Fetches the dd-cart-recommendations section immediately
   on insert (the theme's product-recommendations.js relies on an IntersectionObserver
   that doesn't fire reliably inside the fixed cart drawer). Re-runs each time the drawer
   content re-renders, since a fresh element is created. Handles inline AJAX add and
   refreshes the drawer through the theme's <mini-cart> renderContents. */
if (!customElements.get('dd-cart-crosssell')) {
  class DDCartCrosssell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = '1';
      this.addEventListener('click', this.onClick.bind(this));
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const inner = html.querySelector('product-recommendations');
          if (inner && inner.innerHTML.trim().length) {
            this.innerHTML = inner.innerHTML;
          }
        })
        .catch((e) => console.error('dd-cart-crosssell', e));
    }

    onClick(e) {
      const btn = e.target.closest('.dd-rec-add[data-variant-id]');
      if (!btn || btn.classList.contains('is-loading')) return;
      e.preventDefault();
      btn.classList.add('is-loading');

      // sections the theme's mini-cart needs to re-render (incl. dynamic header/dock ids)
      const ids = [];
      const header = document.getElementById('header');
      if (header && header.dataset.id) ids.push(header.dataset.id);
      ids.push('header-mini-cart-content', 'header-mini-cart-footer');
      const dock = document.getElementById('mobile-dock');
      if (dock && dock.dataset.id) ids.push(dock.dataset.id);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: ids.join(','),
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((state) => {
          const mc = document.querySelector('mini-cart');
          if (mc && typeof mc.renderContents === 'function' && state && state.sections) {
            mc.renderContents(state);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(() => {
          btn.classList.remove('is-loading');
        });
    }
  }
  customElements.define('dd-cart-crosssell', DDCartCrosssell);
}
